












































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { CommonApi } from "@/api/commonApi";
import { getImagePath } from "@/utils/utils";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class BookList extends Vue {
  commonApi = new CommonApi();
  dataList: Array<object> = [];
  pageNum = 1;
  listTotal = 0;
  nickName = "";
  gender = "";
  avaUrl = "";
  historyList: Array<any> = [];

  mounted() {
    this.getUserInfo();
    this.getHistoryList();
  }

  getHistoryList() {
    this.commonApi.getHistoryList().then((res) => {
      if (res.data && res.data.length > 0) {
        //1 浏览，2 评论，3 收藏，4 点赞
        const actionObj: any = {
          1: "阅读",
          2: "发表评论",
          3: "收藏",
          4: "点赞",
        };
        //1 时文，2 图文，3 词典，4 视频，5 书籍
        const contentTypeObj: any = {
          1: "ContentTitle",
          2: "ContentTitle",
          3: "DictionaryName",
          4: "VideoTitle",
          5: "BookTitle",
        };
        //1 时文，2 图文，3 词典，4 视频，5 书籍
        const contentUrlObj: any = {
          1: "/newsDetail",
          2: "/newsDetail",
          3: "/dictionaryList",
          4: "/videoDetail",
          5: "/bookDetail",
        };
        res.data.forEach((item: any, index: number) => {
          this.historyList.push({
            ID: item.ID,
            ContentId: item.ContentId,
            ContentTitle: item[contentTypeObj[Number(item.ContentType)]],
            CreateTime: item.CreateTime,
            ActionName: actionObj[item.ActionType],
            ContentUrl: contentUrlObj[Number(item.ContentType)],
          });
        });
      }
    });
  }

  getUserInfo() {
    this.nickName = sessionStorage["nickName"];
    if (sessionStorage["gender"] == "1") {
      this.gender = "男";
    } else if (sessionStorage["gender"] == "2") {
      this.gender = "女";
    } else {
      this.gender = "保密";
    }
    this.avaUrl = getImagePath(sessionStorage["avaUrl"]);
  }
}
